module.exports = __webpack_public_path__ + "static/media/none.e5a3c195.png";